<div class="container">
  <div class="container-tabs">
    <app-tabs-navigation
      class="tab"
      position="left"
      appearance="modern"
      [tabs]="tab"
      [type]="tabEnum.Render"
      (changeTabsEvent)="changeTabs($event)"
    ></app-tabs-navigation>
  </div>

  <div [ngSwitch]="actionTab">
    <div class="container-content content ui-page-shell-modern">
      <ng-container *ngSwitchCase="configEnum.Email">
        <app-configuracoes-email></app-configuracoes-email>
      </ng-container>
      <ng-container *ngSwitchCase="configEnum.Parameter">
        <app-configuracoes-parametros></app-configuracoes-parametros>
      </ng-container>
      <ng-container *ngSwitchCase="configEnum.TransferConfig">
        <app-configuracoes-repasse></app-configuracoes-repasse>
      </ng-container>
      <ng-container *ngSwitchCase="configEnum.StoreConfig">
        <app-configuracoes-loja></app-configuracoes-loja>
      </ng-container>
      <ng-container *ngSwitchCase="configEnum.ReverseConfig">
        <app-configuracoes-estorno></app-configuracoes-estorno>
      </ng-container>
    </div>
    <div *ngSwitchDefault></div>
  </div>
</div>
